import type { SEOSettings } from './../../../../ricos-types/index.js';

export const getPaywallSeoClass = ({ className = 'paywall', index = 3 }, nodeIndex: number) =>
  nodeIndex < index && className;

export const isPaywallSeo = (seoMode?: SEOSettings) =>
  typeof seoMode === 'object' && typeof seoMode?.paywall === 'object';
